import { Flex } from '@applyboard/crystal-ui';
import { queryParameterContext } from '../context';

import { PageHeader } from '../../../components/PageHeader';
import {
  ProgramsPagination,
  ProgramsTable,
  ProgramLevelFilter,
  QueryFilter,
  FieldOfStudyFilter,
  Sort,
} from '../components';

export function DesktopLayout() {
  return (
    <Flex p={10} gap={8} direction="column">
      <PageHeader title="Program Catalog" />
      <Flex gap={2}>
        <Filter as={<QueryFilter />} width="100%" />
        <Filter as={<ProgramLevelFilter />} width="auto" />
        <Filter as={<FieldOfStudyFilter />} width="auto" />
        <Filter as={<Sort />} width="auto" />
      </Flex>
      <queryParameterContext.FilterSummary />
      <ProgramsTable />
      <ProgramsPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
